/*
 * Copyright (c) 2017-2018. Code réalisé par IpsoSenso
 */

import { flatten } from 'flat'
import { ACTION_TYPE, CUSTOMER_SATISFACTION, FORECAST_PROBABILITY, MANUALLY_CLOSED_STATUS, CONTRACT_MODULE, VIEW, MONTH } from '../enums'
import { LEVEL } from '../constants'

export default flatten({
	title: 'SOLUTION RTV',
	menu: {
		retour: 'Retour à l\'application',
		countries: 'Gestion des pays',
		renegotiation: 'Renegotiation heatmap',
		users: 'Gestion des utilisateurs',
		import: 'Import des utilisateurs'
	},
	renegotiation : {
		message : 'Ajuster chaque case selon la politique commerciale',
		risk_score: 'Contract risk score',
		price_score: 'Contract price score',
		dialog: {
			title: 'Principe de renégociation pour le score risque/prix {risk}/{price}',
			tip: 'Tip',
			cancel: 'Annuler',
			update: 'Mettre à jour'
		}
	},
	searchBar: 'Rechercher contrat, Ingénieur commercial...',
	login: {
		button: 'Enregistrez vous avec Microsoft',
		error: 'Votre compte ne vous permez pas d\'accéder à l\'application'
	},
	layout: {
		dashboard: 'Equipe',
		srOverview: 'Ingénieur commercial',
		contractsOverview: 'Aperçu des contrats',
		portfolio: 'Mon Portefeuille',
		actions: 'Aperçu des actions',
		forecasts: 'Aperçu des anticipations',
		reporting: {
			label : 'Reporting',
			teams: 'Équipes',
			detailed: 'Reporting mensuel'
		},
		notifications: {
			help: {
				title: 'Besoin d\'aide',
				noContract: 'Aucun contrat avec besoin d\'aide',
				needHelp: '{firstName} {lastName} ayant besoin d\'aide sur {customerName} ({id})'
			},
			overdueContracts: {
				title: 'Contrats restés ouverts',
				noContract: 'Pas de contrat restés ouverts',
				contract: '{customerName} ({id}) sur liste prioritaire depuis {nbMonths} mois'
			},
			overdueActions: {
				title: 'Actions en retard',
				noAction: 'Pas d\'action en retard',
				action: '{customerName} ({idContract}): action prévue avant {deadline}'
			}
		},
		logout: 'Se déconnecter'
	},
	search: {
		contracts: {
			title: 'Contrats',
			noResult: 'Aucun résultat trouvé'
		},
		salesRepresentative: {
			title: 'Ingénieur Commercial',
			noResult: 'Aucun résultat trouvé'
		}
	},
	pages: {
		selectCountry: {
			title: 'Sélectionner un pays ou une région',
			indicators: {
				withoutActions: 'Contrats sans actions',
				withActions: 'Contrats avec actions',
				closed: 'Contrats fermés'
			},
			button: 'Tableau de bord équipe',
			seeReporting: 'Accéder au reporting',
			backToHomePage: 'Retour à la page d\'accueil'
		},
		portfolio: {
			title: 'Mon Portefeuille',
			breadcrumbs: 'Mon Portefeuille',
			tabBar: {
				priority: 'Liste Prioritaire',
				monthly: 'Liste prioritaire du mois',
				all: 'Tous les contrats',
				allDetails: 'Tous les détails'
			}
		},
		contractsOverview: {
			title: 'Aperçu des contrats',
			breadcrumbs: {
				dashboard: 'Tableau de bord Equipe',
				contractsOverview: 'Aperçu des contrats'
			},
			tabBar: {
				priority: 'Liste prioritaire',
				cancelled: 'Derniers contrats résiliés',
				all: 'Tous les contrats'
			},
			filters: {
				title: 'Filtres',
				help: 'Sélectionner un ou plusieurs éléments dans une ou plusieurs colonnes pour afficher les contrats correspondant à votre sélection. ',
				reset: 'Réinitialiser les filtres',
				apply: 'Appliquer',
				headers: {
					status: 'Statut des contrats',
					classification: 'Classification',
					risk: 'Score de risque',
					value: 'Score de valeur',
					flags: 'Alerte',
					endDate: 'Date d\'échéance contrats',
					riskTypology: 'Typologie de risque',
					customerFeedback: 'Retour des clients'
				},
				status: {
					toDo: 'PAS D\'ACTION',
					inProgress: 'EN COURS',
					toBeCancelled: 'RÉSILIÉ',
					toBeExtended: 'PROLONGÉ',
					renegociated: 'RENÉGOCIÉ VALEUR ÉGALE',
					upgraded: 'RENEGOCIÉ PLUS-VALUE',
					downgraded: 'RENEGOCIÉ MOINS-VALUE'
				},
				classification: {
					high: 'Haute valeur/risque',
					low: 'Faible valeur',
					manually: 'Ajouté manuellement'
				},
				risk: {
					5: '5 - Haut',
					4: '4 - Moyen',
					3: '3 - Moyen',
					2: '2 - Faible',
					1: '1 - Faible'
				},
				value: {
					5: '5 - Haut',
					4: '4 - Moyen',
					3: '3 - Moyen',
					2: '2 - Faible',
					1: '1 - Faible',
					0: '0 - Négatif'
				},
				flags: {
					help: 'Besoin d\'aide',
					overdue: 'En retard',
					actionsOverdue: 'Actions en retard'
				},
				endDate: {
					outdated: 'Dépassée',
					short: '< 3 mois',
					medium: '3 - 6 mois',
					long: '> 6 mois'
				},
				riskTypology: {
					field: 'Chantier',
					sales: 'Ventes'
				},
				customerFeedback: {
					cancellationLetter: 'Lettre de résiliation reçue',
					claimLetter: 'Lettre de réclamation reçue (12 derniers mois)'
				}
			},
			sorts: {
				title: 'Trier par',
				priority: {
					label: 'Priorité (par défaut)',
					labelShort: 'Priorité'
				},
				risk: {
					label: 'Risque',
					labelShort: 'Risque'
				},
				value: {
					label: 'Valeur',
					labelShort: 'Valeur'
				},
				endDate: {
					label: 'Date d\'échéance contrat',
					labelShort: 'Date de fin'
				},
				unitsNumber: {
					label: 'Nombre d\'appareils',
					labelShort: 'Appareils'
				}
			},
			table: {
				searchBar: {
					classic: 'Recherche par IC, client ou n° de contrat',
					[CONTRACT_MODULE.FR]: 'Recherche par IC, contremaître, technicien, client, n° de contrat ou adresse'
				},
				headers: {
					contract: {
						title: 'Contrat',
						cancelled: {
							title: 'Résilié',
							tooltip: 'Contrat résilié dans Scott'
						},
						needHelp: {
							title: 'Besoin d\'aide'
						}
					},
					status: {
						title: 'Statut de l\'action',
						notPriority: {
							title: 'Pas dans la liste prioritaire',
							tooltip: 'Pour créer des actions sur ce contrat, ouvrir le contrat et cliquer sur Ajouter à la liste prioritaire'
						}
					},
					actionsOpened: 'Actions ouvertes',
					valueIndicator: {
						title: 'Valeur',
						tooltip: 'Score de valeur {indicator}/5 (0 = valeur négative)'
					},
					riskIndicator: {
						title: 'Risque',
						tooltip: 'Indicateur de risque {indicator}/5'
					},
					riskTypology: {
						title: 'Typologie de risque',
						flag: {
							sales: 'Détails alertes ventes',
							field: 'Détails alertes chantier'
						}
					},
					endDate: {
						title: 'Date d\'échéance contrat',
						tooltip: {
							desktop: 'Contrat prioritaire ouvert depuis plus de 3 mois',
							mobile: 'Contrat toujours ouvert',
							contractEndTypology: 'Type d\'échéance contrat :',
							requestedCancellationDate: 'Date de résiliation demandée :'
						}
					},
					unitsNumber: {
						title: 'Appareil(s)',
						tooltip: 'Prix de vente :'
					},
					advancedNoticePeriodDate: 'Date butoire du préavis',
				},
				noResult: 'Pas de contrat trouvé',
				loading: 'Chargement des contrats',
				show: 'afficher le contrat'
			},
			otherContract: {
				title: 'Autres contrats',
				contracts: 'Contrats',
				salesRep: 'Ingénieur commercial.',
				portfolio: 'Mon Portefeuille'
			},
			otherSR: {
				title: 'Autres Ingénieur commercial',
				noResult: 'Pas d\'autre Ingénieur commercial',
				headers: {
					sales: 'Représentant commercial',
					contracts: 'Contrats'
				}
			}
		},
		salePortfolioManager: {
			breadcrumbs: {
				dashboardRegional: 'Région',
				dashboard: 'Équipe',
				srOverview: 'Ingénieur Commercial',
				srPortfolio: '{firstName} {lastName}',
				portfolio: 'Portefeuille'
			},
			title: {
				srPortfolio: '{firstName} {lastName}',
				portfolio: 'Portefeuille'
			}
		},
		contract: {
			comparison: {
				hide: ' Masquer',
				show: ' Montrer',
				text: 'Comparaison de prix par rapport aux autres contrats similaires',
				tooltip: 'Donne une indication de la position du contrat vs autres contrats ayant des caractéristiques similaires (numéro unité, contrat & type de client...) dans porteufille France',
				chart: {
					price: 'Positionnement prix contrat',
					value: 'Positionnement valeur contrat'
				},
				portfolioValue: 'Croissance parc portefeuille (année en cours) : '
			},
			risk: {
				close: {
					title: 'Fermer le risque manuellement',
					outcome: {
						title: 'Résultat',
						to_be_autorenewed: {
							label: 'Doit être prolongé',
							detail: '(Le contrat sera automatiquement renouvelé)'
						},
						to_be_cancelled: {
							label: 'Doit être résilié',
							detail: '(Pas de possibilité de sauver le contrat et va être résilié)'
						},
						renegotiated: {
							label: 'Renégociation finalisée',
							detail: '(Renégocié avec une valeur de contrat stable)'
						},
						upgraded: {
							label: 'Renégociation finalisée avec plus-value',
							detail: '(Renégocié avec augmentation de la valeur contractuelle)'
						},
						downgraded: {
							label: 'Renégociation finalisée avec moins-value',
							detail: '(Renégocié avec diminution de la valeur contractuelle)'
						}
					},
					comment: 'Commentaire',
					cancel: 'Annuler',
					button : 'Fermer le risque manuellement',
					errors: {
						required: 'Requis',
						mandatory: 'Information obligatoire'
					}
				}
			},
			charts: {
				range: 'Champs {rangeMin} {currency} - {rangeMax} {currency}',
				median: 'Médiane {median} {currency}'
			},
			flags: {
				description :{
					ContractAge: 'Age contrat : Le contrat est dans le top 20% des contrats les plus anciens',					
					ContractDuration: 'Prochaine échéance dans moins de 6 mois ou date limite dans moins de 12 mois',					
					Public: 'Contrat public : le client est public',					
					CustomerType: 'Type de client : client propice à renégocier',					
					NationalAccount: 'Compte national : le client est un compte national',					
					Recovery: 'Contrat récup à l\'origine : Contrat initialement en récup',					
					SellingPrice: 'Prix élevé/appareil : le contrat est dans le top 20% des plus haut prix par appareil',					
					ContractValue: 'Haute valeur/appareil : le contrat est dans le top 20% des plus hautes valeur O+T par appareil',					
					Units: 'Nbre d\'app. élevé : contrat dans le top 20% en nbr d\'appareils',					
					Rebel: 'Ratio élevé d\'appareils rebelles : le contrat est dans le top 20% d\'appareils rebelles dans les 12 derniers mois',					
					Callbacks: 'Nbr élevé de pannes par appareil : le contrat est dans le top 20% des pannes/appareil dans les 12 derniers mois',					
					ResponseTime: 'Temps de réponse moyen élevé : le contrat se situe dans le top 20% du temps de réponse moyen par appareil au cours des 12 derniers mois',					
					Availability: 'Disponibilité réduite/appareil : le contrat est dans le top 20% de disponibilité réduite/appareil au cours des 12 derniers mois',					
					MissedMaintenance: 'Visites manquées : le contrat est dans le top 20% du nombre de visites manquées au cours des 12 derniers mois',					
					Trapped: 'Appels pour passager bloqué : le contrat est dans le top 20% du nombre d\'appels pour passagers bloqués au cours des 12 derniers mois'
				},
				close: 'Fermer'
			},
			breadcrumbs: {
				dashboardRegional: 'Région',
				dashboard: 'Equipe',
				srOverview: 'Ingénieur Commercial',
				srPortfolio: '{firstName} {lastName}',
				contract: '{name} ({contractId})',
				myPortfolio: 'Mon portefeuille'
			},
			actions: {
				close: 'Fermer le contrat à risque',
				add: 'Ajouter à la liste de priorité',
				help: {
					title: 'Aide du manager',
					tooltip: 'Demander de l\'aide à votre manager'
				}
			},
			information: {
				title: 'Informations & Gestion des risques',
				status: {
					TODO: 'PAS D\'ACTION',
					IN_PROGRESS: 'EN COURS',
					TO_BE_CANCELLED: 'RÉSILIÉ',
					TO_BE_AUTO_RENEWED: 'PROLONGÉ',
					RENEGOTIATED: 'RENÉGOCIÉ VALEUR ÉGALE',
					UPGRADED: 'RENEGOCIÉ PLUS-VALUE',
					DOWNGRADED: 'RENEGOCIÉ MOINS-VALUE',
					CLOSED_AUTOMATICALLY: 'PROLONGÉ'
				},
				headers: {
					contractValue: {
						title: 'Valeur contrat',
						tooltip: 'Valeur de facturation de O annuelle + ventes T moyennes < 5K€ dans les trois dernière années'
					},
					customerIdCrm: "Numéro client",
					value: 'Valeur',
					riskTypology: {
						title: 'Typologie des risques',
						flags: {
							sales: {
								title: 'Detail alertes ventes',
								name: 'Ventes'
							},
							field: {
								title: 'Détail alertes chantier',
								name: 'Chantier'
							},
						}
					},
					units: 'Appareils',
					price: {
						title: 'PV actuel contrat',
						tooltip: 'Facturation annuelle de O'
					},
					risk: 'Risque',
					callbacks: 'Nombre de pannes',
					endDate: 'Date échéance contrat',
					invoicesValue: 'Valeur factures impayées',
					address: 'Adresse du site',
					renegotiationTip: {
						header: 'Principe de reneg.',
						dialogTitle : 'Principe de renégociation pour ce contrat',
						noTip: 'Ce contrat n\'a pas de facturation et est certainement résilié',
						outlier: 'Ce contrat est très spécifique et nécessite un accord manager pour toute renégociation'
					}
				},
				closed: {
					button: 'Réouverture contrat',
					text: 'Risque fermé le {date} par {firstName} {lastName}',
					textAuto: 'Risque fermé automatiquement le {date}'
				},
				comment: 'Commentaire',
				dialog: {
					error: {
						title: 'Risque peut/ne peut pas être fermé',
						text: 'Toutes les actions doivent être fermées avant de fermer le risque.',
						close: 'Fermer'
					},
					notAvailable: {
						title: 'Action non disponible',
						text: 'Seul votre manager peut réouvrir le risque',
						cancel: 'Fermé'
					},
					reOpen: {
						title: 'Confirmation de réouverture du contrat',
						text: 'Réouvrir le contrat ? La raison de la fermeture du contrat avec le commentaire associé seront effacés.',
						confirm: 'Réouverture du contrat'
					},
					addPriority: {
						title: 'Ajouter à la liste de contrats prioritaire',
						text: 'Ajouter ce contrat à la liste prioritaire ?',
						confirm: 'Ajouter contrat',
						cancel: 'Fermer'
					}
				},
				tabs: {
					tab: {
						details: 'Détails du contrat',
						actions: 'Actions',
						zeroAction: 'Créez votre première action'
					},
					detailsTab: {
						moduleFrance: {
							advancedNoticePeriodDate: 'Date butoire du préavis',
							contractCategory: 'Type de contrat',
							requestedCancellationDate: 'Date de résiliation demandée',
							claimLettersNb: 'Nombre de lettres de réclamation reçues',
							supervisorName: 'CM',
							mechanicName: 'Technicien',
							customerSatisfactionLvl: {
								title: 'Satisfaction client',
								[CUSTOMER_SATISFACTION.UNSATISFIED]: 'Non satisfait',
								[CUSTOMER_SATISFACTION.SATISFIED]: 'Satisfait'
							},
							contractEndTypology: 'Type de fin de contrat',
						},
						comments: {
							empty: 'Aucun commentaire n\'a été fait',
							lastModified: 'Dernière modification le {date} par {firstName} {lastName}',
							updateComment: 'Mettre à jour le commentaire',
							managersTitle: 'Commentaire général des managers',
							srTitle: 'Commentaire général de l\'IC',
							dialog: {
								comment: 'Commentaire',
								cancel: 'Annuler',
								update: 'Mettre à jour'
							}
						}
					}
				}
			},
			forecast: {
				title: 'Anticipation résiliations',
				probability: {
					label: 'Probabilité',
					high: 'FH',
					low: 'FB'
				},
				cancellationMonth: {
					label: 'Mois de résiliation',
				},
				save: 'Sauvegarder l\'anticipation',
				errors: {
					required: 'Requis',
					outdated: 'Anticipation dépassée'
				},
				snackbar: {
					success: 'Anticipation ajoutée',
					error: 'Erreur lors de l\'ajout'
				}
			}
		},
		dashboard: {
			title: 'Tableau de bord Equipe - {level}',
			branch: {
				table: {
					titleNational: 'Contrats ouverts dans le pays',
					titleRegion: 'Contrats ouverts de la région',
					headers: {
						branchName: 'Agence',
						todo: 'Contrats ouverts sans action',
						inProgressCount: 'Contrats ouverts avec actions',
						closedCount: 'Contrats fermés'
					},
					noResult: 'Pas d\'agence trouvée'
				}
			},
			region: {
				table: {
					title: 'Contrats ouverts des régions',
					headers: {
						regionName: 'Région',
						todo: 'Contrats ouverts sans action',
						inProgressCount: 'Contrats ouverts avec actions',
						closedCount: 'Contrats fermés'
					},
					noResult: 'Pas de région trouvée'
				}
			},
			highRisk: {
				table: {
					title: 'Contrats Haute valeur / Haut risque',
					headers: {
						contract: 'Contrat',
						actionsOpened: 'Actions en cours',
						valueIndicator: 'Valeur',
						riskIndicator: 'Risque'
					},
					tooltip: {
						value: 'Score de valeur {indicator}/5 (0 = valeur négative)',
						risk: 'Score de risque {indicator}/5'
					},
					noResult: 'Aucun contrat trouvé'
				},
				button : 'Afficher tous les contrats prioritaires'
			},
			priorityOpenContracts: {
				title: 'Contrats actifs prioritaires',
				indicators: {
					srNeedHelp: 'Besoin d\'aide par IC',
					contractionWithActionsOverdue: 'Contrats avec actions dépassées',
					contractsOverdue: 'Contrats ouverts > 3 mois'
				},
				button: 'Afficher tous les contrats',
				contracts: 'Contrats'
			},
			salesRep: {
				title: {
					national: 'National',
					openContracts: 'Contrats actifs'
				},
				table: {
					headers: {
						lastName: 'Ingénieur Commercial',
						todo: 'Contrats actifs sans actions',
						inProgress: 'Contrats actifs avec actions',
						closed: 'Contrats fermés'
					},
					noResult: 'Aucun Ingénieur Commercial trouvé'
				},
				button: 'Afficher tous les Ingénieurs Commerciaux'
			},
			topPriorityContracts: {
				title: 'Distribution du Top contrats prioritaires',
				tooltip: '{nb} contrats',
				type: {
					noAction: 'Pas d\'action',
					inProgress: 'En cours',
					manuallyClosed: 'Fermé manuellement'
				}
			},
			manuallyClosedContracts: {
				title: 'Contrats prioritaires fermés',
				tooltip: 'Distribution des status fermé&s manuellement (statut des résiliations dans le CRM non pris en compte)',
				headers: {
					all: 'Tous les Contrats',
					high: 'Haute Valeur/Risque',
					low: 'Faible Valeur'
				},
				rows: {
					[MANUALLY_CLOSED_STATUS.TO_BE_CANCELLED]: {
						title: 'A résilier',
						tooltip: 'Pas de possibilités de sauver le contrat et il va être résilié'
					},
					[MANUALLY_CLOSED_STATUS.TO_BE_AUTO_RENEWED]: {
						title: 'A prolonger',
						tooltip: 'Contrat sera automatiquement prolongé'
					},
					[MANUALLY_CLOSED_STATUS.RENEGOTIATED]: {
						title: 'Renégociation finalisée',
						tooltip: 'Contrat renégocié avec valeur égale'
					},
					[MANUALLY_CLOSED_STATUS.UPGRADED]: {
						title: 'Renégocié avec valeur supérieure',
						tooltip: 'Contrat renégocié avec valeur accrue'
					},
					[MANUALLY_CLOSED_STATUS.DOWNGRADED]: {
						title: 'Renégocié avec valeur inférieure',
						tooltip: 'Contrat renégocié avec valeur diminuée'
					}
				}
			}
		},
		srPortfolio: {
			openActions: {
				title: '{count} Action en cours sur mes contrats prioritaires',
				plannedActions: {
					title: 'Planifié',
					tooltip: '{count} actions planifiées'
				},
				overdueActions: {
					title: 'Dépassé',
					tooltip: '{count} actions dépassées'
				},
				button: 'Afficher toutes les actions'
			},
			priorityContracts: {
				title: 'Mes contrats prioritaires actifs',
				noActionPlanned: 'Contrats sans action planifiée',
				highValue: 'Haute Valeur/Risque',
				lowValue: 'Faible Valeur',
				manually: 'Ajouté manuellement',
				nbContracts: '{nb} Contrats'
			},
			followUp: {
				title: 'Suivi des contrats',
				openActions: {
					title: '{count} actions',
					planned: {
						title: 'Planifiée',
						tooltip: '{count} actions planifiées'
					},
					overdue: {
						title: 'Dépassée',
						tooltip: '{count} actions dépassées'
					}
				},
				forecasts: {
					title: 'Anticipation résiliations',
					high: {
						title: 'FH',
						tooltip: '{count} FH'
					},
					low: {
						title: 'FB',
						tooltip: '{count} FB'
					}
				},
				button: 'Afficher tout'
			},
		},
		srOverview: {
			title: {
				mobile: 'Vue Ingénieur Commercial',
				desktop: 'Vue Ingénieur Commercial (contrats prioritaires)'
			},
			breadcrumbs: {
				dashboard: 'Affichage Equipe ',
				srOverview: 'Vue Ingénieur Commercial'
			},
			row: {
				title: '{openContracts} contrats actifs, {totalContracts} total ({openContractsPercentage}%)',
				subtitle: '{nbActions} sans actions'
			},
			table: {
				headers: {
					lastName: 'Ventes',
					openContractsCount: {
						title: 'Contrats actifs',
						text: '{nbContracts} sans actions'
					},
					openActionsCount: {
						title: 'Actions restantes',
						text: '{nbActions} actions dépassées'
					},
					overdueCount: 'Contrats ouverts > 3 mois',
					toBeCancelled: 'A résilier',
					toBeAutoRenewed: 'A prolonger',
					renegotiated: 'Renégocié',
					upgraded: 'Valeur accrue',
					downgraded: 'Valeur diminuée',
					openActions: {
						title: 'Actions ouvertes',
						text: '{nbActions} Dépassées'
					},
					overdueContracts: 'Contrats ouverts > 3 mois'
				},
				noResult: 'Aucun Ingénieur Commercial trouvé'
			}
		},
		reporting : {
			month: {
				[MONTH.JANUARY]: 'Janvier',
				[MONTH.FEBRUARY]: 'Février',
				[MONTH.MARCH]: 'Mars',
				[MONTH.APRIL]: 'Avril',
				[MONTH.MAY]: 'Mai',
				[MONTH.JUNE]: 'Juin',
				[MONTH.JULY]: 'Juillet',
				[MONTH.AUGUST]: 'Août',
				[MONTH.SEPTEMBER]: 'Septembre',
				[MONTH.OCTOBER]: 'Octobre',
				[MONTH.NOVEMBER]: 'Novembre',
				[MONTH.DECEMBER]: 'Décembre'
			},
			filters: {
				level: {
					all: {
						[LEVEL.REGION]: 'Toutes les régions',
						[LEVEL.BRANCH]: 'Toutes les agences',
						[LEVEL.SALES_REP]: 'Tous les ingénieurs commerciaux',
						default: 'Périmètre'
					},
					[LEVEL.REGION]: 'Régions',
					[LEVEL.BRANCH]: 'Agences',
					[LEVEL.SALES_REP]: 'Ingénieurs Commerciaux',
					[LEVEL.USER]: 'Ingénieur Commercial',
					default: 'Périmètre'
				},
				year: 'Année',
				view: {
					label: 'Modèle d\'affichage',
					[VIEW.MONTHLY] : {
						performance : 'Vue mensuelle',
						adoption: 'Moyenne mensuelle'
					},
					[VIEW.YEAR_TO_DATE]: {
						performance: 'Vue cumulée',
						adoption: 'Moyenne annuelle'
					}
				}
			},
			tabBar: {
				adoption:  'Adoption',
				activity: 'Activité',
				performance: 'Performance'
			},
			teams: {
				title: 'Équipes',
				graph: {
					performance: {
						title: '% des contrats sauvegardés par rapport aux contrats perdus',
						legend : 'Pourcentage YTD'
					},
					activity: {
						title: '% des contrats avec actions dépassées',
						legend : 'Pourcentage YTD'
					},
					adoption: {
						title: 'Vue d\'ensemble',
						legend : '% de contrats avec actions + contrats fermés sur l\'ensemble des contrats à risque'
					}
				}
			},
			detailed: {
				title: 'Reporting mensuel',
				perimeter: 'Périmètre',
				graph: {
					title: 'Contrats sauvés',
					value: 'Valeur',
					units: 'App'
				}
			},
			noResult: 'Pas de contrats trouvés',
			performance: {
				table: {
					tooltip : {
						savedContracts : 'Contrats fermés car renégociés ou renouvelés',
						lostContracts: 'Contrats fermés car résiliés',
						savedContractsRate: '% contrats sauvés par rapport aux contrats résiliés',
						renegociatedContractsRate: '% contrats renégociés par rapport aux contrats fermés',
					},
					month: 'Mois',
					savedContracts : '<baliseToolTip>Contrats sauvés {br} (Nb App/valeur)</baliseToolTip>',
					lostContracts: '<baliseToolTip>Contrats perdus {br} (Nb App/valeur)</baliseToolTip>',
					savedContractsRate: '<baliseToolTip>% contrats sauvés {br} (Nb App/valeur)</baliseToolTip>',
					renegociatedContracts: 'Contrats renégociés {br} (Nb App/valeur)',
					renegociatedContractsRate: '<baliseToolTip>% contrats renégociés {br} (Nb App/valeur)</baliseToolTip>',
					total: 'Total'
				},
				tooltip : {
					good: '% des contrats sauvés > 95%',
					bad: '% des contrats sauvés < 80%'
				}
			},
			activity: {
				table: {
					day: 'Jour',
					noActionsContracts : 'Contrats sans actions {br} (Nb App/valeur)',
					contractsWithActions: 'Contrats avec actions {br} (Nb App/valeur)',
					contractsWithActionsRate: '% de contrats avec actions',
					contractsWithOverdueActionsRate: '% de contrats avec actions dépassées',
					contractsWithHelpRequested: 'Nb contrats avec demande d\'aide',
					total: 'Total'
				},
				tooltip : 'Au moins 50% des contrats ouverts devraient avoir une action'
			},
			adoption: {
				table: {
					month: 'Mois',
					nbConnexion : 'Nb de jours de connexion à RTV',
					nbChangementsActions: 'Modifications d\'actions',
					nbActionsOuvertes: 'Nb d\'actions créées dans le mois',
					nbChangementsDate: 'Nb de modifications de dates limites',
					nbAjoutContrats: 'Contrats ajoutés manuellement',
					total: 'Total'
				},
				tooltip : 'Nombre élevé de changements de dates limites'
			},
			level: {
				[LEVEL.COUNTRY]: 'Pays',
				[LEVEL.REGION]: 'Régions',
				[LEVEL.BRANCH]: 'Agences',
				[LEVEL.SALES_REP]: 'Ingénieurs Commerciaux',
				[LEVEL.USER]: 'Ingénieur Commercial',
			}
		}
	},
	valueIcon: {
		high: 'Contrat Haute Valeur/Haut risque prioritaire depuis {month}/{year}',
		low: 'Contrats prioritaires faible valeur depuis {month}/{year}',
		manually: 'Ajouté manuellement à la liste prioritaire'
	},
	router: {
		error: {
			title: 'Connexion perdue',
			content: 'Merci de rafraîchir la page ou connectez-vous à nouveau'
		}
	},
	profiles: {
		ZONE_MANAGER: 'EMEA',
		NATIONAL: 'National',
		BRANCH_MANAGER: 'Responsable d\'Agence',
		SALES_REPRESENTATIVE: 'Ingénieur Commercial',
		BRANCH_MANAGER_ASSISTANT: 'Assistant branch manager',
		REGIONAL_MANAGER: 'Responsable régional'
	},
	actionButton: {
		cancel: 'Annuler'
	},
	language: {
		fr: 'Français',
		en: 'Anglais',
		cze: 'Tchèque',
		de: 'Allemand',
		sp: 'Espagnol',
		pt: 'Portugais',
		ita: 'Italien'
	},
	action: {
		filters: {
			all: 'Afficher toutes les actions',
			open: 'Afficher  les actions en cours',
			closed: 'Afficher les actions terminées'
		},
		form: {
			select: 'Sélectionner une action...',
			comparison: 'Ce contrat est trop spécifique pour afficher une comparaison de prix',
			type: 'Type d\'action',
			deadline: 'Echéance',
			description: 'Description'
		},
		page: {
			title: 'Vue Actions {firstName} {lastName}',
			defaultTitle: 'Vue Actions',
			breadcrumbs: {
				dashboard: 'Vue Equipe',
				srOverview: 'Vue Ingénieur Commercial',
				repPortfolio: 'Portefeuille de {firstName} {lastName}',
				actionsOverview: 'Vue Actions',
				myPortfolio: 'Mon Portefeuille'
			},
			list: {
				noResult: 'Pas d\'actions trouvées',
				headers: {
					action: 'Action',
					status: 'Statut',
					description: 'Description',
					deadline: 'Echéance',
				},
				tooltip: 'Action dépassée',
				button: 'Afficher contrat'
			},
			table: {
				searchBar: 'Rechercher par client, n° de contrat, ou description',
				filters: {
					type: 'Type d\'Action...'
				}
			}
		},
		contract: {
			searchBar: 'Rechercher par la description de l\'action',
			addButton: 'Ajouter une nouvelle action',
			noResult: 'Pas d\'actions trouvées',
			openBy: 'Ouvert par {firstName} {lastName}',
			closedOn: 'Fermé le {date} par {firstName} {lastName}',
			lastModified: 'Dernière modification le {date} par {firstName} {lastName}',
			button: {
				update: 'Mettre à jour l\'action',
				close: 'Fermer l\'action'
			},
			confirmation: {
				title: 'Confirmer la fermeture de l\'action',
				content: 'Fermer l\'action ?',
				buttonLabel: 'Fermer ?',
			},
			new: {
				title: 'ACTION',
				buttonLabel: 'Créer action',
				cancel: 'Annuler'
			},
			update: {
				title: 'ACTION',
				buttonLabel: 'Enregistrer'
			},
			deadline: 'Échéance'
		},
		status: {
			all: 'Toutes les Actions',
			open: {
				label: 'Actions ouvertes',
				chipLabel: 'Ouvert',
			},
			closed: {
				label: 'Actions fermées',
				chipLabel: 'Fermé',
			}
		},
		type: {
			all: {
				label: 'Tous types',
			},
			[ACTION_TYPE.FIRST_CALL]: {
				label: '1er Appel',
				defaultDescription: 'Appeler le client pour vérifier sa satisfaction et le contexte du contrat',
			},
			[ACTION_TYPE.CUSTOMER_MEETING]: {
				label: 'RDV Client',
				defaultDescription: 'Rencontrer le client pour renforcer la relation et vérifier le contexte du contrat',
			},
			[ACTION_TYPE.REPORT_TO_CUSTOMER]: {
				label: 'Transmettre des infos au client',
				defaultDescription: 'Partager information/rapport avec le client pour améliorer sa satisfaction',
			},
			[ACTION_TYPE.PROACTIVE_PROPOSAL]: {
				label: 'Proposition proactive',
				defaultDescription: 'Faire une proposition de renouvellement du contrat avant  son échéance',
			},
			[ACTION_TYPE.RENEGOTIATION]: {
				label: 'Renégociation',
				defaultDescription: 'Faire une proposition de contrat demandé par le client',
			},
			[ACTION_TYPE.DOWNSELL]: {
				label: 'Renégociation avec diminution de valeur',
				defaultDescription: 'Proposer de réduire la valeur du contrat pour rester compétitif',
			},
			[ACTION_TYPE.UPSELL]: {
				label: 'Renégociation avec augmentation de valeur',
				defaultDescription: 'Proposer d\'augmenter la valeur du contrat par des options supplémentaires et/ou un prix supérieur',
			},
			[ACTION_TYPE.SEND_MECHANIC_TO_JOBSITE]: {
				label: 'Envoyer le technicien sur site',
				defaultDescription: 'Régler le problème technique sur l\'appareil',
			},
			[ACTION_TYPE.SEND_SUPERVISOR_TO_JOBSITE]: {
				label: 'Envoyer le contremaître sur site',
				defaultDescription: 'Auditer l\'appareil pour éviter le risque de rappel',
			},
			[ACTION_TYPE.CONTACT_SUPERVISOR_MECHANIC]: {
				label: 'Contacter le contremaître/technicien',
				defaultDescription: 'Comprendre la situation technique de l\'unité',
			},
			[ACTION_TYPE.OTHER]: {
				label: 'Autre',
			},
			[ACTION_TYPE.CUSTOMER_CLAIM]: {
				label: 'Traiter réclamation client'
			},
			[ACTION_TYPE.CANCELLATION_REQUEST]: {
				label: 'Traiter demande de résiliation'
			}
		}
	},
	user: {
		new: {
			title: 'Création d\'utilisateur',
			buttonLabel: 'Créer'
		},
		update: {
			title: 'Modification de l\'utilisateur',
			buttonLabel: 'Mettre à jour'
		},
		form: {
			errors: {
				required: 'Obligatoire',
				invalidFormat: 'Format invalide',
				max255char: '255 caractères maximum',
				emailExists: 'Cette adresse mail existe déjà.',
				emailInactive: 'Cette adresse mail est actuellement inactive.'
			},
			fields: {
				lastName: 'Nom de famille *',
				firstName: 'Prénom *',
				email: 'Email *',
				profile: 'Profil',
				country: 'Pays',
				branches: 'Branche(s)',
				region: 'Région'
			}
		},
		table: {
			headers: {
				lastName: 'Nom de famille',
				firstName: 'Prénom',
				email: 'Email',
				branch: 'Agence(s)',
				profile: 'Profil',
				country: 'Pays',
				region: 'Région'
			},
			actions: {
				reactivate: 'Reactiver',
				modify: 'Modifier',
				deactivate: 'Désactiver'
			},
			filters: {
				searchBar: 'Filtrer par nom d\'utilisateur, email ou agence',
				select: {
					placeholder: 'Profil',
					all: 'Tous les Profils',
					national: 'National',
					branchManager: 'Responsable agence',
					branchManagerAssistant: 'Assistant Branch Manager',
					salesRepresentative: 'Ingénieur Commercial',
					regionalManager: 'Responsable régional'
				},
				switch: 'Montrer utilisateurs désactivés',
				reset: 'REINITIALISER'
			}
		},
		menu: {
			myAccount: 'Mon compte',
			quit: 'Quitter'
		}
	},
	errors: {
		mandatory: 'champs obligatoire',
		onlyFutureDate: 'Date future seulement'
	},
	countries: {
		table: {
			headers: {
				name: 'Nom',
				lowValueThreshold: 'Seuil de valeur basse',
				highRiskValueThreshold: 'Seuil de valeur de risque haut',
				lowValueAmount: 'Nombre de contrat de faible valeur',
				highRiskValueAmount: 'Nombre de contrat de haut risque',
				refresh: 'Mettre à jour lors de l\'import',
				forecastModule: 'Module d\'anticipation'
			},
			actions: {
				modify: 'Modifier'
			},
			values: {
				false: 'Non',
				true: 'Oui'
			}
		},
		dialog: {
			title: 'Modification du pays',
			labels: {
				name: 'Nom *',
				lowValueThreshold: 'Seuil de valeur basse *',
				highRiskValueThreshold: 'Seuil de valeur de risque haut *',
				lowValueAmount: 'Nombre de contrat de faible valeur *',
				highRiskValueAmount: 'Nombre de contrat de haut risque *',
				refresh: 'Mettre à jour lors de l\'import *',
				forecastModule: 'Module d\'anticipation *',
				usdConversionRate: 'Taux de conversion en $'
			},
			values: {
				false: 'Non',
				true: 'Oui'
			},
			actions: {
				cancel: 'Annuler',
				update: 'Mettre à jour'
			},
			errors: {
				required: 'Obligatoire',
				negative: 'La valeur doit être supérieure à 0',
				maximum: 'La valeur doit être inférieure à 1000'
			}
		}
	},
	forecasts: {
		page: {
			title: 'Vue Anticipations {firstName} {lastName}',
			defaultTitle: 'Vue Anticipations',
			breadcrumbs: {
				dashboard: 'Vue Équipe',
				srOverview: 'Vue Ingénieur Commercial',
				repPortfolio: 'Portefeuille de {firstName} {lastName}',
				forecastsOverview: 'Vue Anticipations',
				myPortfolio: 'Mon Portefeuille'
			},
			list: {
				noResult: 'Pas d\'anticipation trouvée',
				searchBar: 'Rechercher par client ou n° de contrat',
				headers: {
					contract: 'Contrat ({contractNumber})',
					status: 'Status',
					units: 'Appareil(s) ({unitsNumber})',
					unitsEmpty: 'Appareil(s)',
					probability: 'Anticipation',
					cancellationMonth: 'Mois de résiliation'
				},
				information: {
					status: {
						TODO: 'PAS D\'ACTION',
						IN_PROGRESS: 'EN COURS',
						TO_BE_CANCELLED: 'RÉSILIÉ',
						TO_BE_AUTO_RENEWED: 'PROLONGÉ',
						RENEGOTIATED: 'RENÉGOCIÉ VALEUR ÉGALE',
						UPGRADED: 'RENEGOCIÉ PLUS-VALUE',
						DOWNGRADED: 'RENEGOCIÉ MOINS-VALUE'
					},
					cancellationMonth: {
						old: 'Anticipation dépassée'
					}
				}
			}
		},
		probability: {
			all: {
				label: 'FB + FH',
			},
			[FORECAST_PROBABILITY.LOW]: {
				label: 'FB',
				defaultDescription: 'Fourchette basse',
			},
			[FORECAST_PROBABILITY.HIGH]: {
				label: 'FH',
				defaultDescription: 'Fourchette haute',
			},
		},
		cancellationMonth: {
			all: {
				label: 'Tous les mois'
			},
			outdated: {
				label: 'Passées'
			}
		}
	},
	import: {
		form: {
			country: {
				label: 'Pays',
				errors: {
					required: 'Obligatoire',
				}
			},
			file: {
				label: 'Fichier',
				empty: 'Aucun fichier',
				button: 'Choisir un fichier',
				errors: {
					required: 'Obligatoire',
					wrongFormat: 'Mauvais format de fichier'
				}
			},
			submit: 'Importer'
		},
		results: {
			header: {
				added: 'Nombre d\'utilisateur ajouté: {count}',
				errors: 'Nombre d\'erreur: {count}'
			},
			success: 'Utilisateur ajouté: {email}',
			errors: {
				regionMissing: 'ID de région manquant: {email}',
				branchNotInRegion: 'Branche sans lien avec la région indiquée: {email}',
				branchNotFound: 'Branche non existante: {email}',
				regionNotFound: 'Région non existante: {email}',
				branchMissing: 'ID de branche manquant: {email}',
				profile: 'Profil inexistant: {email}',
				noRegionInCountry: 'Pas de région dans ce pays: {email}',
				emailFormat: 'Format d\'email invalide: {email}',
				emailMissing: 'Email manquant à la ligne {line}',
				emailMissingExtended: 'Email manquant pour {name} à la ligne {line}',
				wrongProfile: 'Profile en base ({profileDB}) différent du fichier ({profileFile}): {email}'
			}
		}
	},
	crm: {
		btn: 'Lancer l\'export vers le CRM Italie',
		success: 'Succès de l\'export des contrats Italie vers le CRM',
		error: 'Erreur lors de l\'export des contrats Italie vers le CRM',
		loading: 'Export des contrats Italie vers le CRM en cours',
		date: {
			title: 'Date',
			helperText: 'Format requis : dd-mm-yyyy',
			invalid: 'Format invalide'
		}
	}
})
